export default "__VITE_ASSET__59ad87f5__"